import type { BadgeColor } from '@/shared/types/badge';
import type { CatalogCardMediaIndicatorTooltipProps, CatalogCardTag } from '../types';

/** Etiqueta ya normalizada para badges y mediciones. */
export type NormalizedCatalogCardTag = {
  label: string;
  color: BadgeColor;
  tooltip?: string;
  tooltipProps?: CatalogCardMediaIndicatorTooltipProps;
};

/**
 * Convierte `tags` del catálogo (`string` o `{ label, color? }`) en filas con color por defecto `accent`.
 */
export function normalizeCatalogCardTags(
  tags: (string | CatalogCardTag)[] | undefined
): NormalizedCatalogCardTag[] {
  if (!tags?.length) return [];
  return tags.map((t) => {
    if (typeof t === 'string') {
      return { label: t, color: 'accent' as BadgeColor };
    }
    const tip = t.tooltip?.trim();
    return {
      label: t.label,
      color: t.color ?? 'accent',
      ...(tip ? { tooltip: tip, tooltipProps: t.tooltipProps } : {}),
    };
  });
}
